import { Accordion, Divider } from '@wix/design-system';
import React from 'react';
import { dataHooks } from '../../utils/datahooks';
import { useRuleGroupList } from './use-rule-group-list';
export const RuleGroupList = _ref => {
  let {
    ruleGroups,
    parentNodeRef,
    dataHook,
    hideShadow,
    accordionSize = 'tiny',
    accordionSkin = 'neutral'
  } = _ref;
  const {
    ruleGroupItems
  } = useRuleGroupList({
    parentNodeRef,
    ruleGroups
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Accordion, {
    contentPadding: "none",
    dataHook: dataHooks.groupsList(dataHook),
    hideShadow: hideShadow,
    horizontalPadding: "medium",
    items: ruleGroupItems,
    size: accordionSize,
    skin: accordionSkin,
    transitionSpeed: "slow"
  }), /*#__PURE__*/React.createElement(Divider, null));
};
//# sourceMappingURL=rule-group-list.js.map